import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Divider, List } from 'semantic-ui-react';
import { kindToLabel } from '../../utils/useful_functions';
import { getLayers, setLayers } from '../../utils/mapUtils';
import { useSelector } from 'react-redux';

export const lineBreak = '---';
export const allLayers = [
  'network_site',
  'subscriber_site',
  'ptp_link',
  'access_point',
  'mesh_link',
  'pmp_link',
  lineBreak,
  'network_site_label',
  'subscriber_site_label',
];

const LayerList = () => {
  const [visibleLayers, setVisibleLayers] = React.useState(getLayers());
  const [visibleLayersTimestamp] = useSelector((state) => [
    state.map.visibleLayersTimestamp,
  ]);

  React.useEffect(() => {
    setVisibleLayers({ ...getLayers() });
  }, [visibleLayersTimestamp]);

  const handleLayerChange = (i) => {
    return (e) => {
      let newState = { ...visibleLayers };
      newState[i] = !visibleLayers[i];
      setVisibleLayers({ ...newState });
      setLayers(newState);
    };
  };

  let checkItems = [];
  allLayers.forEach((i) => {
    if (i === lineBreak) {
      checkItems.push(<Divider />);
    } else {
      const label = kindToLabel(i, true);
      const checked = visibleLayers[i];
      checkItems.push(
        <List.Item key={i} onClick={handleLayerChange(i)}>
          <List.Icon name={checked ? 'checkmark box' : 'square outline'} />
          <List.Content>{label}</List.Content>
        </List.Item>
      );
    }
  });

  return (
    <List selection className="layers">
      {checkItems}
    </List>
  );
};

export default LayerList;
